import declentionsMap from "./declentions"

export function wordNumDeclention (amount = 0, wordKey) {
    const words = declentionsMap[wordKey]
    amount = Math.abs(amount) % 100
    const num = amount % 10
    if (amount > 10 && amount < 20) { return words[2] }
    if (num > 1 && num < 5) { return words[1] }
    if (num === 1) { return words[0] }
    return words[2]
}